<mat-dialog-content class="contract-dialog">

  <button mat-icon-button class="close-btn" (click)="cancel()">
    <mat-icon>close</mat-icon>
  </button>
  <h2 class="title">{{ data.config.TITLE }}</h2>

  <div class="content">
    <p [innerHTML]="data.config.MESSAGES.DRAFT_INFO "></p>

    <ul>
      <li *ngFor="let item of data.config.MESSAGES.RESTRICTIONS">
        <strong>{{ item }}</strong>
      </li>
    </ul>

    <p *ngIf="data.mode === mode; else incompleteText">
      {{ data.config.MESSAGES.DRAFT_QUESTION }}
    </p>
  </div>

  <div class="actions">

  <!-- LEFT SIDE (only for draft mode) -->
  <thera-button *ngIf="data.mode === mode" [config]="data.config.BUTTONS.CANCEL" (click)="cancel()">

  </thera-button>

  <!-- RIGHT SIDE -->
  <div class="right-buttons">

    <!-- Draft mode -->
    <ng-container *ngIf="data.mode === mode">
      
      <thera-button class="ml-2" [config]="data.config.BUTTONS.SAVE_DRAFT" (click)="saveDraft()"></thera-button>
      <thera-button class="ml-2" [config]="data.config.BUTTONS.FINALIZE" (click)="finalize()"></thera-button>
    </ng-container>

    <!-- Incomplete mode -->
    <ng-container *ngIf="data.mode !== mode">
      <thera-button class="ml-2" [config]="data.config.BUTTONS.CANCEL" (click)="cancel()">

      </thera-button>

      <thera-button class="ml-2" [config]="data.config.BUTTONS.SAVE_NO_FINALIZE" (click)="saveDraft()">

      </thera-button>
    </ng-container>

  </div>
</div>

</mat-dialog-content>
<ng-template #incompleteText>
    <p>{{ data.config.MESSAGES.INCOMPLETE_QUESTION }}</p>
</ng-template>
